import type { Squad } from '../../../types';

export interface LocationEnrollmentRow {
  locationId: string;
  label: string;
  squads: number;
  seats: number;
}

export function groupSquadsByLocationId(squads: Squad[]): LocationEnrollmentRow[] {
  const grouped = new Map<string, LocationEnrollmentRow>();
  for (const squad of squads) {
    const locationId = String(squad.locationId || '').trim();
    if (!locationId) continue;
    const existing = grouped.get(locationId) || {
      locationId,
      label: String(squad.locationName || locationId).trim() || locationId,
      squads: 0,
      seats: 0,
    };
    existing.squads += 1;
    existing.seats += Array.isArray(squad.studentIds) ? squad.studentIds.length : 0;
    grouped.set(locationId, existing);
  }
  return Array.from(grouped.values())
    .sort((a, b) => b.seats - a.seats || b.squads - a.squads || a.locationId.localeCompare(b.locationId));
}
